export default {
      id: "oc-dashboard-server-number-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-dashboard-server-number",
      toString: function () {
        return this.url;
      }
    }